import {useEffect, useState} from "react";
import {useLexicalComposerContext} from "@lexical/react/LexicalComposerContext";
import {classNames} from "@utils/class-names";
import {getTextLengthFromEditorState} from "@common/rich-text-length";

interface CharCountPluginProps {
    maxLength?: number;
}

const CharCountPlugin = ({maxLength}: CharCountPluginProps) => {
    const [editor] = useLexicalComposerContext();
    const [count, setCount] = useState(0);

    useEffect(() => {
        return editor.registerUpdateListener(({editorState}) => {
            const length = getTextLengthFromEditorState(editorState);
            setCount(length);
        });
    }, [editor]);

    if (maxLength === undefined) return null;

    const isOver = count > maxLength;

    return (
        <div className={classNames(
            "flex justify-end text-xs mt-4",
            isOver ? "text-red-500" : "text-on-surface/40"
        )}>
            {count} / {maxLength}
        </div>
    );
};

export default CharCountPlugin
